import React from 'react'

const Checked: React.FC = () => {
  return (
    <svg viewBox="0 0 16 16" fill="currentColor"><path fillRule="evenodd" d="M6.7847,10.9609 L6.07759322,10.2537932 L6.0777,10.2537932 L3.9997,8.1759 L4.70680678,7.46879322 L6.7847,9.54679322 L11.2925932,5.03879322 L11.9997,5.7459 L6.7847,10.9609 Z"></path></svg>
  )
}

export default Checked